<div class="container">
  <div class="row">
    <div class="col-sm-none col-md-3 col-lg-2">
      <app-nav></app-nav>
    </div>
    <div class="content col-sm-12 col-md-9 col-lg-10">
      <app-home></app-home>
    </div>
  </div>
</div>